import axios from "axios";
import { getUserToken } from "./firebase";

export const fetchWithAuth = axios.create({
    baseURL: import.meta.env.VITE_CHORIPAN_URL,
});

fetchWithAuth.interceptors.request.use(async (config) => {
    const idToken = await getUserToken();

    if (!idToken) {
        throw new Error("idToken is undefined");
    }

    config.headers.Authorization = `Bearer ${idToken}`;

    // For FormData, explicitly delete Content-Type to let axios set it with boundary
    if (config.data instanceof FormData) {
        delete config.headers["Content-Type"];
    } else {
        config.headers["Content-Type"] = "application/json";
    }

    return config;
});

export const fetchWithoutAuth = axios.create({
    baseURL: import.meta.env.VITE_CHORIPAN_URL,
});
